import ABCyaPhaser from "@abcya/abcya_phaser";
import gameData from "../gameData";
import Clock from "./Clock";

export default class NavBar extends Phaser.GameObjects.Container
{
    constructor(scene)
    {
        super(scene);
        scene.add.existing(this);

        this.scene = scene;

        this.spacer = 20;
        this.score = 0;
		
        this.createNav();
    }

	createNav() {
        this.scoreCont = this.scene.add.container();
        this.timeCont = this.scene.add.container();
        this.add(this.scoreCont);
        this.add(this.timeCont);

        this.pauseBtn = ABCyaPhaser.Buttons.addSimpleButton(this.scene.mid.x*2 - 35 - this.spacer, -40, "pause_button", null, ()=>{
            this.pauseBtn.setEnabled(false);
            ABCyaPhaser.Audio.playOneShot("Click", this.scene);
            
            this.scene.showPopup("paused");
        }, this).setEnabled(false);

        this.scorePanel = ABCyaPhaser.Images.addImage(0, 0, "score_display", this.scoreCont);
        this.scoreTxt = ABCyaPhaser.Text.addText(this.scorePanel.width/6, -3, 25, "0xFFFFFF", gameData.GAME_FONTS[0], String(this.score), this.scoreCont);

        this.timePanel = ABCyaPhaser.Images.addImage(0, 0, "timer_display", this.timeCont);

        this.timeCont.setPosition(this.pauseBtn.x - this.timePanel.width/2 - this.pauseBtn.width/2 - this.spacer, this.pauseBtn.y);
        this.scoreCont.setPosition(this.scorePanel.width/2 + this.spacer, this.pauseBtn.y);

        this.clock = new Clock(this.scene, this, 3, 0);
        this.clock.x = this.timePanel.getBounds().width/8;
        this.clock.y = -3;

        ABCyaPhaser.Tweens.addTween(this, 1000, {y:this.pauseBtn.height + this.spacer}, Phaser.Math.Easing.Quadratic.Out, ()=>{
            this.clock.countdown();
            this.pauseBtn.setEnabled(true);
        });
	};

    setScore(type){
        if(type == "+"){
            this.score++;
            gameData.WORDS_MADE++;

            this.scoreTxt.destroy();
            this.scoreTxt = null;

            this.scoreTxt = ABCyaPhaser.Text.addText(this.scorePanel.width/6, -3, 25, "0xFFFFFF", gameData.GAME_FONTS[0], String(this.score), this.scoreCont);
        }
        if(type == "-"){
            gameData.WORDS_MISSED++;
        }
    };

    callParentAbility(type){
        if(type == "end"){
            gameData.GAME_DONE = true;

            this.scene.showPopup("end");
            this.pauseBtn.setEnabled(false);

            ABCyaPhaser.Tweens.addTween(this, 1000, {y:-40}, Phaser.Math.Easing.Quadratic.Out, ()=>{
                this.timeTween?.pause();

                this.removeAll();
            });
        }
        if(type == "create"){
            if(!gameData.GAME_PAUSED){
                console.log("creating rocket");
                this.scene.createRockets();
            }
        }
    };
}